import { Component, EventEmitter, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfiguracionesService } from 'src/app/services/configuraciones.service';
import { MedicosService } from 'src/app/services/medicos.service';
import { TratamientosService } from 'src/app/services/tratamientos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'tratamienos-registro',
  templateUrl: './tratamientos-registro.component.html',
})

export class TratamientosregistroComponent {

  formTratamiento: FormGroup;
  detalle_tratamiento: FormArray;
  @Input() public id_tratamiento = "";
  @Input() public tipo;
  public event: EventEmitter<any> = new EventEmitter();

  public doctores = null;
  public total = 0;

  public datos_tratamiento = {
    "tratamiento" : {
      "id_bas_tratamiento" : "",
      "descripcion" : "",
      "costo" : "",
      "tratamiento" : "",
      "tecnico" : "",
      "tipo" : "",
    },
    "relacion_tratamiento":[],
    "detalle" : [
      {
        "id_bas_dettratamientos" : "",
        "descripcion" : "",
        "monto" : "",
        "tecnico" : ""
      }
    ]
  };

  constructor(
    public activeModal: NgbActiveModal,
    private _bilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private _tratamientosService: TratamientosService,
    private _configuracionesService: ConfiguracionesService,
    private _medicosService: MedicosService,
  ){

  }

  ngOnInit(){

    this.obtenerMedicos();
    this.colocarValores();

    if( this.id_tratamiento != "" ){
      this.obtenerTratamiento();
    }

  }

  colocarValores( tratamiento = null ){
    let datos = null;
    if( tratamiento != null ){
      let meds = tratamiento.relacion_tratamiento;
      let meds_temp = [];
      for(let i=0; i < meds.length; i++ ){
        let id = meds[i].id_doctores;
        meds_temp.push( id.toString() )
      }
      tratamiento.relacion_tratamiento = meds_temp;
      datos = tratamiento;
    }else{
      datos = this.datos_tratamiento;
    }

    this.formTratamiento = this._bilder.group({
      id_bas_tratamiento : [ datos.tratamiento.id_bas_tratamiento ],
      descripcion: [datos.tratamiento.descripcion, Validators.compose([ Validators.maxLength(45), Validators.required ])],
      costo: [ datos.tratamiento.costo, Validators.maxLength(45)  ],
      id_doctores: [ datos.relacion_tratamiento, Validators.required ],
      detalle_tratamiento: this._bilder.array([  ])
    });
    let sum = 0;
    if( tratamiento != null ){
      let detalle = tratamiento.detalle;
      for(let i=0; i < detalle.length; i++ ){
        sum += parseFloat( detalle[i].monto );
        this.addItem(detalle[i]);
      }
    }else{
      this.addItem();
    }
    this.total = sum;
  }

  createDetalle(datos = null): FormGroup {

    let id_bas_dettratamientos = "";
    let descripcion = "";
    let monto = "";
    let tecnico = false;

    if(datos != null){
      id_bas_dettratamientos = datos.id_bas_dettratamientos;
      descripcion = datos.descripcion;
      monto = datos.monto;
      tecnico = (datos.tecnico == '1' || datos.tecnico == 1)? true: false;
    }

    return this._bilder.group({
      id_bas_dettratamientos: [ id_bas_dettratamientos ],
      descripcion: [ descripcion, Validators.required ],
      monto: [ monto, Validators.required ],
      tecnico: [ tecnico ]
    });
  }

  addItem(datos = null): void {
    this.detalle_tratamiento = this.formTratamiento.get('detalle_tratamiento') as FormArray;
    this.detalle_tratamiento.push(this.createDetalle(datos));
  }

  deleteItem(item){
    if(this.detalle_tratamiento != undefined ){
      if(this.detalle_tratamiento.length > 0){
        this.detalle_tratamiento.removeAt(item);
      }
    }
  }

  sumar(){
    var items = $(".monto");
    var sum:any = 0;
    items.each(function (index, elem) {
        var val:any =  $(elem).val();
        var priceValue:any =  Number(val.replace(/[^0-9\.]+/g,""));
        sum = parseInt(sum) + parseInt(priceValue);
    });

    this.total = sum;
  }

  obtenerMedicos(){
    let respuesta = this._medicosService.obtenerMedicos();
    respuesta.then( val =>{
      if( val.status == "success" ){
        if(val.meds != null ){
          this.doctores = val.meds;
        }
      }
    });
  }

  obtenerTratamiento(){
    this.spinner.show('spnr-s');
    let respuesta = this._tratamientosService.obtenerTratamiento( this.id_tratamiento );
    respuesta.then( val =>{
      if( val.status == "success" ){
        if(val.tratamiento != null ){
          this.colocarValores( val.tratamiento );
          this.spinner.hide('spnr-s');
        }
      }
    });
  }

  displayFn(elemento): string {
    return elemento ? elemento.texto : elemento;
  }

  registrarTratamiento( datos ){
    this.spinner.show('spnr-s');
    let respuesta = null;
    let mensaje = null;

    if( this.id_tratamiento == "" ){
      respuesta = this._tratamientosService.registrarTratamiento( datos );
      mensaje = "Tratamiento Registrado Exitosamente";
    }else{
      respuesta = this._tratamientosService.actualizarTratamiento( datos );
      mensaje = "Tratamiento Actualizado Exitosamente";
    }

    respuesta.then( val =>{
      if( val.status == "success" ){
        this.activeModal.close();
        this.spinner.hide('spnr-s');
        Swal.fire({
          title: mensaje,
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#1beb11',
        });
        this.event.emit(1);
      }else{
        this.spinner.hide('spnr-s');
        Swal.fire({
          title: 'Oopss...',
          text: val.message,
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#1beb11',
        });
      }
    });

  }

}
